<template>
  <Row style="padding: 5px">
    <Form ref="formData" :model="formData" :rules="rules">
      <Row>
        <Col :xs="24" :sm="24" :md="12" class="left__col">
          <!-- NAME -->
          <FormItem :label="getSchema('name').label" prop="name">
            <Input
              v-model="formData.name"
              :placeholder="getSchema('name').label"
            ></Input>
          </FormItem>

          <!--COUNTRY-->
          <FormItem :label="getSchema('country').label" prop="country">
            <Select
              v-model="formData.country"
              @on-change="changeCountry"
              filterable
            >
              <Option
                v-for="item in getSchema('country').choices"
                :value="item.value"
                :key="item.value"
              >{{ item.display_name }}</Option
              >
            </Select>
          </FormItem>

          <!--REGION-->
          <FormItem :label="getSchema('region').label" prop="region">
            <Select v-model="formData.region" filterable>
              <Option
                v-for="item in formSelectOptions.region"
                :value="item.id"
                :key="item.id"
              >{{ item.name }}</Option
              >
            </Select>
          </FormItem>

          <!--CURRENCY ISO-->
          <FormItem :label="getSchema('currency_iso').label" prop="currency_iso">
            <Select v-model="formData.currency_iso" filterable>
              <Option
                v-for="item in getSchema('currency_iso').choices"
                :value="item.value"
                :key="item.value"
              >{{ item.display_name }}</Option
              >
            </Select>
          </FormItem>

          <!--DISPLAY CURRENCY-->
          <FormItem :label="getSchema('currency').label" prop="currency">
            <Input
              v-model="formData.currency"
              :placeholder="getSchema('currency').label"
            ></Input>
          </FormItem>

          <!--KASPI QR-->
          <FormItem :label="getSchema('kaspi_qr').label" prop="kaspi_qr">
            <Input
              v-model="formData.kaspi_qr"
              :placeholder="getSchema('kaspi_qr').label"
            ></Input>
          </FormItem>

        </Col>


        <Col :xs="24" :sm="24" :md="12" class="right__col">
          <!--PHONE-->
          <FormItem :label="getSchema('phone').label" prop="phone">
            <Input
              v-model="formData.phone"
              :placeholder="getSchema('phone').label"
            ></Input>
          </FormItem>

          <!--EMAIL-->
          <FormItem :label="getSchema('email').label" prop="email">
            <Input
              v-model="formData.email"
              :placeholder="getSchema('email').label"
            ></Input>
          </FormItem>

          <!--WEBSITE-->
          <FormItem :label="getSchema('website').label" prop="website">
            <Input
              v-model="formData.website"
              :placeholder="getSchema('website').label"
            ></Input>
          </FormItem>

          <!--TIMEZONE-->
          <FormItem :label="getSchema('timezone').label" prop="timezone">
            <Select v-model="formData.timezone" filterable>
              <Option
                v-for="item in getSchema('timezone').choices"
                :value="item.value"
                :key="item.value"
              >{{ item.display_name }}</Option
              >
            </Select>
          </FormItem>

          <!--TAXATION TYPE-->
          <FormItem :label="getSchema('taxation_type').label" prop="taxation_type">
            <Select v-model="formData.taxation_type" filterable>
              <Option
                v-for="item in getSchema('taxation_type').choices"
                :value="item.value"
                :key="item.value"
              >{{ item.display_name }}</Option
              >
            </Select>
          </FormItem>

          <!--LEGAL FORM-->
          <FormItem :label="getSchema('legal_form').label" prop="legal_form">
            <Select v-model="formData.legal_form" filterable>
              <Option
                v-for="item in getSchema('legal_form').choices"
                :value="item.value"
                :key="item.value"
              >{{ item.display_name }}</Option
              >
            </Select>
          </FormItem>
        </Col>
      </Row>










<!--      &lt;!&ndash;USE FISCAL&ndash;&gt;-->
<!--      <FormItem :label="getSchema('use_fiscal').label" prop="use_fiscal">-->
<!--        <i-switch v-model="formData.use_fiscal" size="large">-->
<!--          &lt;!&ndash;<span slot="open">On</span>&ndash;&gt;-->
<!--          &lt;!&ndash;<span slot="close">Off</span>&ndash;&gt;-->
<!--        </i-switch>-->
<!--      </FormItem>-->

      <FormItem class="text-right">
        <Button
          type="success"
          @click="saveAction()"
          :disabled="disabledSaveButton"
          >Сохранить</Button
        >
        <!--<Button type="primary" @click="saveAction()" :disabled="!validForm">Сохранить</Button>-->
      </FormItem>
    </Form>
    <Spin size="large" fix v-if="loading"></Spin>
  </Row>
</template>

<script>
import { base_url } from "../../http.js";

export default {
  name: "companyMainSettings",
  data() {
    return {
      loading: true,
      baseViewUrl: base_url + "/company/main/",
      schema: {},
      rules: {},
      validForm: false,
      isChanged: false,

      formData: {
        name: "",
        country: "",
        region: "",
        currency_iso: "",
        currency: "",
        kaspi_qr: "",
        phone: "",
        email: "",
        website: "",
        timezone: ""
      },
      formSelectOptions: {
        region: []
      }
    };
  },

  computed: {
    disabledSaveButton() {
      return !this.isChanged || !this.validForm;
    }
  },

  methods: {
    fetchSchema() {
      this.$http.options(this.baseViewUrl).then(response => {
        this.schema = response.data.actions.PUT;
        this.getRules();
      });
    },

    fetchInitialData() {
      this.$http
        .get(this.baseViewUrl)
        .then(response => {
          this.formData = response.data;

          for (let field in this.formData) {
            this.formData[field] = response.data[field];
          }

          this.fetchSchema();

          this.getRegions(this.formData.country);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    getSchema(name) {
      return this.schema[name];
    },

    validateForm() {
      this.$refs.formData.validate(valid => {
        this.validForm = valid;
      });
    },

    saveAction() {
      if (this.validForm) {
        this.save();
      } else {
        this.$Message.error("Некорректно заполнены поля!");
      }
    },

    save() {
      this.loading = true;
      this.$http
        .put(this.baseViewUrl, this.formData)
        .then(response => {
          let data = response.data;
          this.$store.commit("company_name", data.name);
          this.$store.commit("use_fiscal", data.use_fiscal);

          this.$Message.success("Успешно сохранено");
          this.isChanged = false;
        })
        .finally(() => {
          this.loading = false;
        })
        .catch(error => {
          this.$Notice.open({
                    title: 'Ошибка',
                    desc: 'Для редактирования организации необходимо закрыть все смены на кассах организации'
                });
            });
    },

    getRules() {
      for (let field in this.schema) {
        if (this.schema[field].required) {
          this.rules[field] = [
            {
              required: true,
              message: this.schema[field].help_text,
              trigger: "blur"
            }
          ];

          // this.$watch('formData.' + field, function (newValue, oldValue) {
          //   this.validateForm();
          // });
        }

        this.$watch("formData." + field, function(newValue, oldValue) {
          this.validateForm();
          this.isChanged = true;
        });
      }
    },

    changeCountry(val) {
      this.formData.region = "";
      if (val) {
        this.getRegions(val);
      }
    },
    getRegions(country) {
      const url = base_url + "/options/regions/?country=" + country;
      this.$http.get(url).then(result => {
        this.formSelectOptions.region = result.data.results;
      });
    }
  },
  watch: {
    // 'formData.country': function(val){
    //   this.formData.region = '';
    //   if (val) {
    //     this.getRegions(val);
    //   }
    // }
  },
  created() {
    this.fetchInitialData();
  }
};
</script>

<style scoped>
.demo-spin-container {
  display: inline-block;
  width: 200px;
  height: 100px;
  position: relative;
  border: 1px solid #eee;
}

  .left__col {
    padding-right: 50px;
    border-right: 1px dashed rgba(14, 37, 74, 0.3)
  }

  .right__col {
    padding-left: 50px;
  }


@media screen and (max-width: 767px) {
  .left__col {
    padding-right: 0;
    border-right: none;
  }

  .right__col {
    padding-left: 0;
  }

  .text-right {
    text-align: left;
  }
}


</style>



// WEBPACK FOOTER //
// src/apps/company/companyMainSettings.vue